import { AxiosInstance } from "axios";

interface QuarterlySummary {
  solicitations: number;
  agencies: number;
  videoSubmissions: number;
}

interface QuarterlySummaryData {
  quarters: {
    [quarterKey: string]: Omit<QuarterlySummary, "quarter">;
  };
  lastUpdated: string;
}

interface QuarterlySummaryResponse {
  data: QuarterlySummaryData;
}

export const fetchCommunityQuarterlySummary = (
  api: AxiosInstance
): Promise<QuarterlySummaryResponse> => {
  return api.get("/community_requests/quarterly_summary");
};
